<!--创建节点-->
<template>
  <div class="createNodeBody">
    <p>节点列表(至少需要有一个节点)</p>
    <scheduleAxis
      ref="scheduleAxisBean"
      :dataList="nodeList"
      @addItem="addNode"
      @deleteItem="nodeList.remove($event)"
      @checkItem="checkItem($event)"
      @editItem="editNode"
      nameKey="nodeName"
    ></scheduleAxis>
    <div class="selectNodeValue">
      <div>
        <p v-show="nowNode != undefined">节点类型(必选)</p>
        <singleSelection
          v-show="nowNode != undefined"
          class="singleSelection"
          :nameKey="'name'"
          :list="nodeTypeList"
          :autoCheck="autoCheck"
          @checkItem="selectNodeType($event)"
        ></singleSelection>
      </div>
      <div>
        <p v-show="nowNode != undefined">节点负责人(必选)</p>
        <p
          @click="addUsers"
          v-show="nowNode != undefined"
          :title="nowNodeUserName"
          style="text-overflow: ellipsis;max-width: 70%;overflow: hidden;white-space: nowrap;"
          class="pickerText"
        >
          {{ nowNodeUserName }}
        </p>
      </div>
    </div>
    <div v-show="nowNode != undefined && nowNode.nodeType == 0" class="flexBetween ">
      <div class="itemDiv">
        <p>操作项</p>
        <div class="hideBar" style="overflow-x: hidden;overflow-y: auto;height: 140px;">
          <p v-for="item in itemList" class="itemText" :class="{ isCheck: nowItem == item }" @click="nowItem = item">
            {{ item.title }}
          </p>
        </div>
        <p class="addItem flexBetween">
          <span @click="addItem">+ 新增</span>
          <span @click="deleteItem">- 删除</span>
        </p>
      </div>
      <div class="itemDiv">
        <p>操作步骤</p>
        <div class="hideBar" style="overflow-x: hidden;overflow-y: auto;height: 140px;">
          <table width="100%" cellspacing="0" class="nomal-table">
            <tr style="border-bottom: #CECECE dashed 1px;">
              <th style="width: 20%;">名称</th>
              <th style="width: 20%;">类型</th>
              <th style="width: 60%;">描述</th>
            </tr>
            <tr
              v-for="action in actionList"
              class="itemText"
              :class="{ isCheck: nowAction == action }"
              @click="nowAction = action"
            >
              <td>{{ action.actionName }}</td>
              <td>{{ action.valueTypeName }}</td>
              <td>{{ action.content }}</td>
            </tr>
          </table>
        </div>
        <p class="addItem flexStart">
          <span @click="addAction">+ 新增</span>
          <span @click="deleteAction">- 删除</span>
        </p>
      </div>
    </div>
    <div v-if="nowNode != undefined && nowNode.nodeType == 2" class="selectArchives">
      <p>台账设备(必选)</p>
      <!--addArchives-->
      <p
        @click="dialogVisible = true"
        :title="nowNodeArchivesName"
        style="text-overflow: ellipsis;max-width: 70%;overflow: hidden;white-space: nowrap;"
        class="pickerText"
      >
        {{ nowNodeArchivesName }}
      </p>
      <div class="archivesListContainer">
        <div class="archivesList">
          <span
            class="archiveName"
            :class="{ archiveNameSelected: archive.linkObject == nowArchive.linkObject }"
            v-for="archive in getArchiveDefectList"
            @click="clickArchive(archive)"
            v-if="getArchive"
            >{{ archive.title }}</span
          >
          <span
            class="archiveName"
            :class="{ archiveNameSelected: archive.id == nowArchive.id }"
            v-for="archive in nowNode.archivesIds"
            @click="nowArchive = archive"
            v-show="!getArchive"
            >{{ archive.name }}</span
          >
          <!-- <span class="archiveName" :class="{'archiveNameSelected':archive.name == nowArchive.name}" v-for="archive in nowNode.archivesIds" @click="nowArchive = archive">{{ archive.name }}</span> -->
        </div>
        <div class="defectList">
          <div class="defectMessageBox" v-for="defect in nowArchiveDefectList">
            <p class="defectTitle">{{ defect.name }}</p>
            <p><span class="defectLabel">缺陷等级：</span>{{ priorityMatch[defect.priority] }}</p>
            <p><span class="defectLabel">缺陷危害：</span>{{ defect.harm }}</p>
            <p><span class="defectLabel">处理建议：</span>{{ defect.proposal }}</p>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="台账设备" :visible.sync="dialogVisible" width="50%">
      <el-form :model="form" ref="form" label-width="100px" class="demo-ruleForm">
        <el-form-item label="搜索：">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
        </el-form-item>
        <el-form-item label="台账设备：">
          <el-tree
            :filter-node-method="filterNode"
            ref="tree"
            :props="props"
            :data="archiveTree"
            show-checkbox
            :node-key="'id'"
            :default-expand-all="false"
            :default-expanded-keys="nodeArchives"
            :default-checked-keys="nodeArchives"
            @check-change="handleCheckChange"
          >
          <span slot-scope="{node, data}">
            <img src="../../../../public/static/image/elTree/1.9.png" style="margin-right: 5px;" v-show="node.data.type=='group'"/>
            <img src="../../../../public/static/image/elTree/2.1.png" style="margin-right: 5px;" v-show="node.data.entityName == 'AppEquipmentArchives'"/>
            <span>{{node.label }}</span>
          </span>
          </el-tree>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="addArchives">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import resourcesStore from '@/cache/resourcesStore.js';
import treeSingleSelection from '@/components/module/selection/base/treeSingleSelection.vue';
import scheduleAxis from '@/components/module/axis/scheduleAxis.vue';
import singleSelection from '@/components/module/selection/singleSelection.vue';
export default {
  components: {
    treeSingleSelection,
    scheduleAxis,
    singleSelection
  },
  props: {
    nowFlow: {
      type: Object
    }
  },
  data() {
    return {
      props: {
        children: 'next',
        label: 'name',
        value: 'id'
      },
      dialogVisible: false,
      form: {},
      nowArchiveDefectList: [],
      nowNode: undefined,
      nowItem: undefined,
      nowAction: undefined,
      nowArchive: { name: '' },
      nodeTypeList: [
        {
          name: '自定义',
          value: 0
        },
        {
          name: '现场交底',
          value: 1
        },
        {
          name: '巡检',
          value: 2
        },
        {
          name: '审批',
          value: 3
        }
      ],
      arAchiveList: undefined, //台账设备列表
      getArchive: true, //默认显示加载的台账设备
      filterText: '',
      nowCheckNodes: []
    };
  },
  created() {},
  mounted() {
    this.$store.archivesStore.commit('getArchivesTree');
  },
  destroyed() {},
  computed: {
    nodeArchives() {
      if (this.nowNode != undefined && this.nowNode.hasOwnProperty('next') && !isempty(this.nowNode.next)) {
        return this.nowNode.next.map(archive => {
          return archive.linkObject;
        });
      }
    },
    nowUnit() {
      return this.$store.unitStore.state.nowUnit;
    },
    nodeList() {
      return this.nowFlow == undefined ? [] : this.nowFlow.next;
    },
    getArchiveDefectList: {
      get() {
        if (!isempty(this.nowFlow) && !isempty(this.nowFlow.next)) {
          let nowNode = this.nowFlow.next.filter(item => {
            return item.nodeType == 2;
          });
          this.clickArchive(nowNode[0].next[0]);
          return nowNode[0].next;
        } else {
          return [];
        }
      },
      set(val) {
        return [];
      }
    },
    itemList() {
      return this.nowNode == undefined ? [] : this.nowNode.next;
    },
    actionList() {
      if (this.nowItem == undefined) {
        return [];
      }
      for (var i = 0, len = this.nowItem.next.length; i < len; i++) {
        var item = this.nowItem.next[i];
        item.valueTypeName = this.$store.enumStore.getters.getValueTypeNameByValueType(item.valueType);
      }
      return this.nowItem.next;
    },
    userTree() {
      return this.$store.userStore.getters.getUnitUserTree;
    },
    archiveTree() {
      return [this.$store.archivesStore.state.archivesTree];
    },
    nowNodeUserName() {
      if (this.nowNode == undefined) {
        return '';
      }
      if (isempty(this.nowNode.nodeUsers)) {
        return '点击选择负责人';
      }
      return this.nowNode.nodeUsers[0].hasOwnProperty('username')
        ? this.nowNode.nodeUsers[0].username
        : this.nowNode.nodeUsers[0].userName;
    },
    nowNodeArchivesName() {
      return '点击选择台账设备';
    },
    autoCheck() {
      return this.nowNode != undefined ? this.nowNode.nodeType : 0;
    },
    priorityMatch() {
      return this.$store.orderGroupStore.state.priorityMatch;
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    nodeList(nv, ov) {
      if (nv == undefined || nv.length == 0) {
        this.nowNode = undefined;
        return;
      }
      //if(nv.length > 0) {
      if (nv.length == 1) {
        this.nowNode = nv[0];
        this.$refs.scheduleAxisBean.nowItem = nv[0];
      } else if (nv.length > 1) {
        this.nowNode = nv[nv.length - 1];
        this.$refs.scheduleAxisBean.nowItem = nv[nv.length - 1];
      }
    },
    itemList(nv, ov) {
      if (nv == undefined || nv.length == 0) {
        this.nowItem = undefined;
        return;
      }
      if (nv.length > 0) {
        this.nowItem = nv[0];
      }
    },
    nowNode(nv, ov) {
      this.nowArchiveDefectList = [];
      // 节点类型为巡检需检查台账设备选择情况
      if (isempty(nv) || isempty(nv.nodeType)) {
        return;
      }
      if (nv.nodeType == 2) {
        if (!isempty(nv.next)) {
          if (nv.hasOwnProperty('archivesIds') && !isempty(nv.archivesIds)) {
            this.nowArchive = copy(nv.archivesIds[0]);
          }
        }
      }
    },
    nowArchive(nv, ov) {
      this.getNowArchiveDefectList();
    },
    userTree(nv, ov) {}
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    checkItem(item) {
      this.nowNode = item;
    },
    addUsers() {
      var nodeUsers = [];
      if (this.nowNode != undefined && this.nowNode.hasOwnProperty('nodeUsers') && !isempty(this.nowNode.nodeUsers)) {
        for (var i = 0, len = this.nowNode.nodeUsers.length; i < len; i++) {
          var item = this.nowNode.nodeUsers[i];
          nodeUsers.push(item.hasOwnProperty('userId') ? item.userId : item.id);
        }
      }
      this.$dialogMethod.openSingleItemDialog('节点负责人', this.userTree, nodeUsers, respon => {
        this.$set(this.nowNode, 'nodeUsers', respon);
      });
    },
    handleCheckChange(data, checked, indeterminate) {
      let nowCheckNodes = this.$refs.tree.getCheckedNodes()
      this.nowCheckNodes = 
        nowCheckNodes.filter(item => {
          return item.entityName == 'AppEquipmentArchives';
		})
    },
    addArchives() {
		this.dialogVisible = false
    this.getArchive = false
    this.$set(this.nowNode, 'archivesIds', this.nowCheckNodes)
		if(this.nowNode.archivesIds.length == 0){
			this.nowArchiveDefectList = []
		}
    this.nowArchive = isempty(this.nowCheckNodes) ? {} : this.nowCheckNodes[0]
    },
    getNowArchiveDefectList() {
      if (isempty(this.nowArchive)) {
        this.nowArchiveDefectList = [];
        return;
      }
      this.$api.workDefectApi.findDefectListByArchivesId(this.nowArchive.id, respon => {
        this.nowArchiveDefectList = respon[0].defectList;
      });
    },
    clickArchive(data) {
      if (isempty(data)) {
        this.nowArchiveDefectList = [];
        return;
      }
      this.nowArchive = data;
      this.$api.workDefectApi.findDefectListByArchivesId(data.linkObject, respon => {
        this.nowArchiveDefectList = respon[0].defectList;
      });
    },
    getAllUserList(list, userIds) {
      var resultList = [];
      for (var i = 0, len = list.length; i < len; i++) {
        var item = list[i];
        if (item.type == 'PcmUser') {
          if (userIds.includes(item.id)) {
            resultList.push(item);
          }
        } else {
          //递归找下级
          resultList.addAll(this.getAllUserList(item.next, userIds));
        }
      }
      return resultList;
    },
    addNode() {
      if (this.nowFlow == undefined) {
        this.$dialogMethod.showMessage('请先选中或新增一个工作流!');
        return;
      }
      this.$dialogMethod.openNomalInputDialog(
        '新增节点',
        [
          {
            name: '节点名称',
            pkid: 'nodeName'
          }
        ],
        respon => {
          this.nodeList.push({
            nodeName: respon.nodeName,
            next: [],
            nodeUsers: [],
            archivesIds: [],
            nodeType: 0
          });
          if (this.nodeList.length == 1) {
            this.nowNode = this.nodeList[0];
            this.$refs.scheduleAxisBean.nowItem = this.nowNode;
          } else if (this.nodeList.length > 1) {
            this.nowNode = copy(this.nodeList[this.nodeList.length - 1]);
            this.$refs.scheduleAxisBean.nowItem = this.nowNode;
          }
        }
      );
    },
    editNode(item) {
      this.$dialogMethod.openNomalInputDialog(
        '编辑节点',
        [
          {
            name: '节点名称',
            pkid: 'nodeName',
            defaultValue: item.nodeName
          }
        ],
        respon => {
          this.$set(item, 'nodeName', respon.nodeName);
        }
      );
    },
    // 选择节点类型
    selectNodeType(item) {
      if (this.nowNode == undefined) {
        return;
      }
      this.$set(this.nowNode, 'nodeType', item.value);
    },
    addItem() {
      if (this.nowNode == undefined) {
        this.$dialogMethod.showMessage('请先选中或新增一个节点!');
        return;
      }
      this.$dialogMethod.openNomalInputDialog(
        '新增操作项',
        [
          {
            name: '操作项名称',
            pkid: 'title'
          }
        ],
        respon => {
          this.itemList.push({
            title: respon.title,
            next: []
          });
          if (this.itemList.length == 1) {
            this.nowItem = this.itemList[0];
          }
        }
      );
    },
    deleteItem() {
      if (this.nowItem == undefined) {
        this.$dialogMethod.showMessage('请先选中一个操作项!');
        return;
      }
      this.itemList.remove(
        this.itemList.findIndex(item => {
          return item == this.nowItem;
        })
      );
    },
    addAction() {
      if (this.nowItem == undefined) {
        this.$dialogMethod.showMessage('请先选中或新增一个操作项!');
        return;
      }
      this.$dialogMethod.openNomalInputDialog(
        '新增操作步骤',
        [
          {
            name: '操作步骤名称',
            pkid: 'actionName'
          },
          {
            name: '描述',
            pkid: 'content',
            type: 1
          },
          {
            name: '类型',
            pkid: 'valueType',
            type: 7,
            defaultValue: 0,
            dataList: this.$store.enumStore.state.valueTypeList
          }
        ],
        respon => {
          this.actionList.push({
            actionName: respon.actionName,
            content: respon.content,
            valueType: respon.valueType.value,
            valueTypeName: this.$store.enumStore.getters.getValueTypeNameByValueType(respon.valueType.value)
          });
        }
      );
    },
    deleteAction() {
      if (this.nowAction == undefined) {
        this.$dialogMethod.showMessage('请先选中一个操作项!');
        return;
      }
      this.actionList.remove(
        this.actionList.findIndex(item => {
          return item == this.nowAction;
        })
      );
    },
    getData() {
      return this.nodeList.map(item => {
        var itemC = copy(item);
        itemC.nodeUsers = item.nodeUsers.map(user => {
          return user.userId;
        });
        if (isempty(item.archivesIds)) {
          itemC.archivesIds = '';
        } else {
          itemC.archivesIds = item.archivesIds
            .map(archive => {
              return archive.id;
            })
            .join(',');
        }
        return itemC;
      });
    }
  }
};
</script>

<style scoped>
.itemDiv {
  background: white;
  border: silver solid 0.01rem;
  min-width: 2rem;
  height: 220px;
  display: inline-block;
  margin: 10px;
  color: black;
  border-radius: 5px;
}

.itemDiv:last-child {
  width: calc(100% - 2rem);
}

.itemDiv > p:first-child {
  font-weight: bold;
  border-bottom: #000000 dashed 0.01rem;
}

.itemDiv > div {
  overflow-y: auto;
  max-height: 3rem;
}

.hideBar .itemText:hover {
  background: skyblue;
  color: white;
}

.hideBar .itemText {
  border-bottom: #cecece dashed 1px;
  cursor: pointer;
}

.itemDiv p {
  padding: 0.1rem;
}

.isCheck {
  background: skyblue;
  color: white;
}

.createNodeBody {
  color: black;
}

.createNodeBody > p {
  margin: 0.1rem;
}

.addItem {
  border-top: #cecece 1px dashed;
}

.addItem > span {
  cursor: pointer;
  padding: 0 20px;
  color: skyblue;
}

.addItem > span:hover {
  color: steelblue;
}

.nomal-table {
  border-collapse: collapse;
}

.nomal-table td,
.nomal-table th {
  padding: 5px 2px;
  border-right: #cecece dashed 1px;
}

.selectNodeValue {
  display: flex;
  justify-content: flex-start;
  padding: 0 10px;
}

.selectArchives {
  padding: 0 10px;
  margin: 20px 0;
}

.archivesListContainer {
  min-height: 160px;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  border: solid 1px #e4e4e4;
  padding-bottom: 10px;
}

.archivesList {
  width: 200px;
  height: auto;
}

.archiveName {
  display: block;
  width: 100%;
  text-align: center;
  padding: 5px 0;
  border-bottom: solid 1px #e4e4e4;
  border-right: solid 1px #e4e4e4;
  border-radius: 4px;
}

.archiveNameSelected {
  background-color: #ecf5ff;
  color: #409eff;
}

.defectList {
  width: calc(100% - 220px);
  margin: 10px;
}

.defectMessageBox {
  border: solid 1px #e4e4e4;
  border-radius: 2px;
  padding: 10px 15px;
  margin-bottom: 10px;
  position: relative;
}

.defectMessageBox:hover {
  border-color: #0099ff;
}

.defectMessageBox > p {
  line-height: 28px;
}

.defectTitle {
  font-weight: bold;
}

.defectLabel {
  color: #cccccc;
  margin-left: 30px;
}

.defectLabel:first-child {
  margin: 0;
}
</style>
